ConfirmController.$inject = ["$location", "$rootScope", "$sce"];
import 'font-awesome/css/font-awesome.css';
import 'bootstrap-social/bootstrap-social.css';
angular.module('calendarApp').controller('ConfirmController', ConfirmController);

function ConfirmController($location, $rootScope, $sce) {
  var confirm = this;

  confirm.init = function () {
    // Get appointments and payment info from storage
    var appointments = localStorage.getItem('new-appointments'),
        paymentState = localStorage.getItem('payment-state');

    if (!appointments || appointments === 'undefined') {
      localStorage.removeItem('confirmed-appointments');
      localStorage.removeItem('payment-state');
      $location.path('/');
      return;
    }

    confirm.paymentState = paymentState ? JSON.parse(paymentState) : null;
    confirm.appointments = JSON.parse(appointments);
    confirm.currencySettings = smooth.currencySettings;
    confirm.social = smooth.social && smooth.social.confirmationpage && (smooth.social.facebook || smooth.social.twitter || smooth.social.instagram || smooth.social.youtube || smooth.social.linkedin) ? smooth.social : null;
    var service = confirm.appointments[0].serviceid;
    service.instructions = service.instructions && service.instructions.trim();
    confirm.zoom = confirm.appointments.find(function (appt) {
      return appt.zoom && appt.zoom.join_url;
    });

    if (service.instructions && service.instructions.length > 10) {
      confirm.serviceInstructions = $sce.trustAsHtml(service.instructions);
    }

    gtag('event', 'appointment made', {
      event_category: 'appointments',
      event_label: 'appointment made',
      value: confirm.appointments.length
    });
  };

  confirm.init();

  confirm.backToHome = function () {
    delete $rootScope.newAppointments;
    localStorage.removeItem('new-appointments');
    localStorage.removeItem('payment-state');
    $location.path('/');
  };
}